<script setup lang="ts">
import { computed } from 'vue'
import { NSwitch, NFormItem } from 'naive-ui'
import CFileAttributes from '@lib/components/CFileAttributes/CFileAttributes.vue'
import useAppStore from '@browser/stores/app'
import type { Form } from './UploadFilesModal.vue'

const props = defineProps<{
  modelValue: Form
  showConvertPptxToHtml?: boolean
  convertPptxToHtml?: boolean
}>()

const form = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
})

const emit = defineEmits<{
  (e: 'update:modelValue', form: Form): void
  (e: 'update:convertPptxToHtml', value: boolean): void
}>()

const { appName } = useAppStore()
</script>

<template>
  <div class="flex flex-col gap-4">
    <CFileAttributes v-model="form" :app-name="appName" />
    <NFormItem v-if="showConvertPptxToHtml" :label="$t('canvasUI.browserApp.uploadFilesModal.convertPptxToHtml')">
      <NSwitch :value="convertPptxToHtml" @update:value="(val) => emit('update:convertPptxToHtml', val)" />
    </NFormItem>
  </div>
</template>
